import { camelCase, compact, each, includes, map, trim, zipObject } from 'lodash';

const SEPARATOR = '|';
const ALL_KEYS = ['name', 'type', 'size', 'width', 'height', 'tileWidth', 'tileHeight', 'title', 'description'];
const NUMERIC_KEYS = ['size', 'width', 'height', 'tileWidth', 'tileHeight', 'title'];

export const createDirectoryItemResponse = (value) => {
  if (!value || !value.length || typeof value !== 'string') {
    return;
  }

  if (!includes(value, SEPARATOR)) {
    throw new Error('Value cannot be parsed.');
  }

  // Split the raw value into a values array
  let dataStruct = value.split(SEPARATOR);
  // Map keys to values creating a dictionary
  const props = zipObject(ALL_KEYS, dataStruct);

  // Convert numeric values to numbers
  each(NUMERIC_KEYS, (attr) => {
    const val = props[attr];
    if (val) {
      props[attr] = Number(props[attr]);
    }
  });

  // If there's extended properties, add them as well.
  if (dataStruct.length > ALL_KEYS.length) {
    dataStruct = dataStruct.splice(ALL_KEYS.length);
    each(dataStruct, (datum) => {
      datum = datum.split('=');
      props[camelCase(datum[0])] = trim(datum[1]);
    });
  }

  return props;
};

export const createDirectoryResponse = (data) => {
  data = data.split('\r\n');
  const children = compact(map(data, createDirectoryItemResponse));

  return {
    children,
    files: children.filter(child => child.type !== 'dir'),
    folders: children.filter(child => child.type === 'dir')
  };
};
